(() => {
  /*
   * The anchor in the address bar never reaches Liquid, so the server marks the
   * link that asks for the page itself — About Us — and cannot know that you
   * arrived at #values. This reconciles the two: with an anchor in the URL, the
   * link carrying that anchor takes the mark, and the plain page link gives it
   * up. Without one, the server's answer stands.
   */
  const SELECTOR = '.bk-nav__item, .bk-mega__link, .bk-mnav__link, .bk-footer__link';
  const MARK = 'is-current';

  const linksHere = () => {
    const here = window.location.pathname.replace(/\/$/, '') || '/';
    return [...document.querySelectorAll(SELECTOR)].filter((el) => {
      const href = el.getAttribute('href');
      if (!href || href.startsWith('http') || href.startsWith('mailto:')) return false;
      const url = new URL(href, window.location.origin);
      return (url.pathname.replace(/\/$/, '') || '/') === here;
    });
  };

  const apply = () => {
    const hash = window.location.hash;
    const links = linksHere();
    if (!links.length) return;

    /* No anchor to honour: leave the page as the server drew it. */
    if (!hash) return;

    const wanted = links.filter((el) => (el.getAttribute('href') || '').endsWith(hash));
    if (!wanted.length) return;

    links.forEach((el) => el.classList.remove(MARK));
    wanted.forEach((el) => el.classList.add(MARK));
  };

  /* The server's mark is the starting point, so restore it when the anchor goes. */
  const plain = () => {
    const links = linksHere();
    links.forEach((el) => el.classList.remove(MARK));
    links
      .filter((el) => !(el.getAttribute('href') || '').includes('#'))
      .forEach((el) => el.classList.add(MARK));
  };

  const update = () => (window.location.hash ? apply() : plain());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update, { once: true });
  } else {
    update();
  }
  window.addEventListener('hashchange', update);
})();
